









































































































































import {
  EventManagementEventDTO,
  EventManagementEventService as eventApi,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import { STATUS_ARRAY, STATUS_NAME } from "@/model/event";
import PaginateModel from "@/model/paginate";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QMultiSelect,
  },
})
export default class EventListComponent extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public statuses = [...[this.selectedAllStatus], ...STATUS_ARRAY];

  public headers = [
    { id: "start_datetime", name: "開催日時", order: "desc" },
    { id: "pre_entry_end_time", name: "抽選申込期日", order: "" },
    { id: "authority", name: "作成者" },
    { id: "title", name: "タイトル" },
    { id: "total", name: "購入希望者数" },
    { id: "", name: "" },
    { id: "open_status", name: "", order: "" },
    { id: "", name: "" },
  ];

  public initialSearch = {
    status: ["all"],
    title: null,
    sort: "start_datetime",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};

  public events: EventManagementEventDTO[] = [];

  public mounted() {
    this.initSearch();
    this.filterData();
  }

  public initSearch(): void {
    const query = this.$router.currentRoute.query;
    this.searchParams = {
      ...this.initialSearch,
      ...query,
    };
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router.replace({ name, params, query });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.status && query.status.includes("all")) {
        query.status = [];
      }
      if (!Array.isArray(query.status)) {
        query.status = [query.status];
      }

      const { data } = await eventApi.adminEvent(query);
      this.pagination = new PaginateModel({
        page: data.paginator.currentPage,
        pageCount: data.paginator.lastPages,
        start: data.paginator.currentPage,
        end: data.paginator.lastPages,
        count: data.paginator.total,
      });
      this.events = data.events;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initialSearch };
  }

  public getStatus(item: EventManagementEventDTO): string {
    return item.status_name ? item.status_name : STATUS_NAME[item.open_status];
  }

  public async listPrint(eventId: number) {
    window.open(`/setting/print/${eventId}`, "_blank");
  }

  public hasRole(roles: string | string[]) {
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(store.state.Auth.admin_user.role.name);
  }

  public previewEntries(event) {
    window.open(`/event/ticket/${event.id}`, "_blank");
  }
}
